import React from 'react'

export default function Spinner() {
    return (
        <div className="spinner-background">
            <div className="spinner"></div>
        </div>
    )
}